module.exports = __webpack_public_path__ + "assets/img/算法分批2.5f8426d3.jpg";